import React from "react";
import MuiBox from "@mui/material/Box";
import Text from "components/common/Text";
import {
  ACTIVE_PILL_SX,
  NAV_COLORS,
  NAV_TRANSITION,
} from "components/allInOneDashboard/constants/navTheme";

const NavPill = ({
  label,
  active = false,
  disabled = false,
  onClick,
  labelClassName = "nav-label",
}) => (
  <MuiBox
    onClick={() => !disabled && onClick?.()}
    sx={{
      minWidth: active ? 135 : "auto",
      px: active ? 3 : 0,
      py: 1.625,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.45 : 1,
      whiteSpace: "nowrap",
      flexShrink: 0,
      position: "relative",
      zIndex: 1,
      ...(active ? ACTIVE_PILL_SX : { bgcolor: "transparent" }),
      transition: `min-width ${NAV_TRANSITION}, padding ${NAV_TRANSITION}, background ${NAV_TRANSITION}, box-shadow ${NAV_TRANSITION}, border ${NAV_TRANSITION}`,
      "&:hover": disabled
        ? {}
        : {
            [`& .${labelClassName}`]: active
              ? {}
              : { color: NAV_COLORS.activeGradientEnd },
          },
    }}
  >
    <Text
      className={labelClassName}
      sx={{
        fontSize: active ? { xs: 16, md: 18 } : 16,
        fontWeight: 400,
        color: active ? "#fff" : NAV_COLORS.inactiveNav,
        letterSpacing: active ? "-0.54px" : "-0.48px",
        lineHeight: 1,
        transition: `color ${NAV_TRANSITION}, font-size ${NAV_TRANSITION}`,
      }}
    >
      {label}
    </Text>
  </MuiBox>
);

export default NavPill;
